<template>
    <div class="filePreview">
    	<div class="previewPrint">
    		<div class="preview-flip-container p-b-20">
    			<div class="flipper">
    				<div class="front" v-if="hasFronts()">
    					<div class="preview frontpreview">
    						<!-- MASK PREVIEW -->
    						<div class="previewMask1 boxsize hide">
    							<img :src="fileUrl('foil_front')" class="auto" alt=""/>
    						</div>
    						<div class="previewMask2 boxsize hide">
    							<img :src="fileUrl('spot_uv_front')" class="auto" alt=""/>
    						</div>
    						<div class="previewTrim boxsize">
    							<img :src="fileUrl('front')" class="auto" alt="" />
    						</div>
    					</div>
    					<div class="previewLabel text-center p-10 block">
                            <strong>Front</strong>
                        </div>
    				</div>

    				<div class="back" v-if="hasBacks()">
    					<div class="preview backpreview">
    						<!-- MASK PREVIEW -->
    						<div class="previewMask1 boxsize hide">
    							<img :src="fileUrl('foil_back')" class="auto" alt=""/>
    						</div>
    						<div class="previewMask2 boxsize hide">
    							<img :src="fileUrl('spot_uv_back')" class="auto" alt=""/>
    						</div>
    						<div class="previewTrim boxsize">
                                <img :src="fileUrl('back')" class="auto" alt=""/>
    						</div>
    					</div>
                        <div class="previewLabel text-center p-10 block">
                            <strong>Back</strong>
                        </div>
    				</div>
    			</div>
    		</div>

    		<div class="previewControls group row m-b-20" v-if="hasFronts() && hasBacks()">
                <div class="col-xs-6">
                    <button class="btn btn-success viewfront block">View Front</button>
                </div>
                <div class="col-xs-6">
                    <button class="btn btn-primary primarybg hover primaryborder viewback block">View Back</button>
                </div>
    		</div>
    	</div>

    	<div class="previewViews group" v-if="hasFoil() || hasSpot()">
    		<!-- SPOT MASK -->
            <div class="viewBtns m-b-20" v-if="hasSpot()">
                <div class="checkbox m-r-15">
                    <input type="checkbox" id="spotuvmask" class="spotuvmask" name="spotuvmask"/>
                    <label for="spotuvmask" @click="toggle('.previewMask2')" class="spotuvmask">
                        Show Spot UV Mask
                    </label>
                </div>
    		</div>

            <!-- FOIL MASK -->
            <div class="viewBtns m-b-20" v-if="hasFoil()">
                <div class="checkbox m-r-15">
                    <input type="checkbox" id="foilmask" class="foilmask" name="foilmask"/>
                    <label for="foilmask" @click="toggle('.previewMask1')" class="foilmask">
                        Show Foil Mask
                    </label>
                </div>
    		</div>
    	</div>
    </div>
</template>

<script>
export default {
    name: 'FilePreview',
    data () {
        return {
            files: {
                default: null
            }
        }
    },
    beforeMount () {
        this.files = this.$store.state.template.files
    },
    methods: {
        setPreview (file) {
            if (file.includes('front')) {
                $('.viewfront').trigger('click')
            } else if (file.includes('back')) {
                $('.viewback').trigger('click')
            }

            if (file.includes('spot_uv')) {
                $('.previewMask2').removeClass('hide')
                $('#spotuvmask').prop('checked', true)
            } else {
                $('.previewMask2').addClass('hide')
                $('#spotuvmask').prop('checked', false)
            }

            if (file.includes('foil')) {
                $('.previewMask1').removeClass('hide')
                $('#foilmask').prop('checked', true)
            } else {
                $('.previewMask1').addClass('hide')
                $('#foilmask').prop('checked', false)
            }
        },
        /**
         * Get the preview url of a template file
         * @param  {string} File position (front, back, foil_front, foil_back, spot_uv_front, spot_uv_back)
         * @return {string} File preview url
         */
        fileUrl: function ($position) {
            let url = null
            let append = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

            if ($position === 'front' && this.files.front !== undefined && this.files.front.preview !== undefined) {
                url = (this.files.front.preview.includes('base64')) ? this.files.front.preview : this.files.front.preview + '?' + append
            } else if ($position === 'back' && this.files.back !== undefined && this.files.back.preview !== undefined) {
                url = (this.files.back.preview.includes('base64')) ? this.files.back.preview : this.files.back.preview + '?' + append
            } else if ($position === 'spot_uv_front' && this.files.spot_uv_front !== undefined && this.files.spot_uv_front.preview !== undefined) {
                url = (this.files.spot_uv_front.preview.includes('base64')) ? this.files.spot_uv_front.preview : this.files.spot_uv_front.preview + '?' + append
            } else if ($position === 'spot_uv_back' && this.files.spot_uv_back !== undefined && this.files.spot_uv_back.preview !== undefined) {
                url = (this.files.spot_uv_back.preview.includes('base64')) ? this.files.spot_uv_back.preview : this.files.spot_uv_back.preview + '?' + append
            } else if ($position === 'foil_front' && this.files.foil_front !== undefined && this.files.foil_front.preview !== undefined) {
                url = (this.files.foil_front.preview.includes('base64')) ? this.files.foil_front.preview : this.files.foil_front.preview + '?' + append
            } else if ($position === 'foil_back' && this.files.foil_back !== undefined && this.files.foil_back.preview !== undefined) {
                url = (this.files.foil_back.preview.includes('base64')) ? this.files.foil_back.preview : this.files.foil_back.preview + '?' + append
            }

            return url
        },
        /**
         * Check if the template has front files
         * @return {Boolean}
         */
        hasFronts: function () {
            if (this.files.front || this.files.foil_front || this.files.spot_uv_front) {
                return true
            }
            return false
        },
        /**
         * Check if the template has back files
         * @return {Boolean}
         */
        hasBacks: function () {
            if (this.files.back || this.files.foil_back || this.files.spot_uv_back) {
                return true
            }
            return false
        },

        toggle: function (target) {
            $(target).toggleClass('hide')
        },

        /**
         * Check if the template has foil files
         * @return {Boolean}
         */
        hasFoil: function () {
            if (this.files.foil_front || this.files.foil_back) {
                return true
            }
            return false
        },
        /**
         * Check if the template has spot files
         * @return {Boolean}
         */
        hasSpot: function () {
            if (this.files.spot_uv_front || this.files.spot_uv_back) {
                return true
            }
            return false
        }
    }
}
</script>



// WEBPACK FOOTER //
// FilePreview.vue?5b81a810